<main class="main" id="top">
  <div class="container" data-layout="container">
    <div class="row flex-center min-vh-100 py-6">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
        <a class="d-flex flex-center mb-4" href="../../index.html"><img class="mr-2" src="../../assets/img/illustrations/falcon.png" alt="" width="58" /><span class="text-sans-serif font-weight-extra-bold fs-5 d-inline-block">falcon</span></a>
        <img class="bg-auth-circle-shape" src="../../assets/img/illustrations/bg-shape.png" alt="" width="250">
        <img class="bg-auth-circle-shape-2" src="../../assets/img/illustrations/shape-1.png" alt="" width="150">
        <div class="card">
          <div class="card-body p-4 p-sm-5">
            <div class="text-center">
              <img class="d-block mx-auto mb-4" src="../../assets/img/illustrations/envelope.png" alt="Email" width="70" />
              <h4>Please check your email!</h4>
              <p>
                An email has been sent to <strong>xyz@abc.com</strong>. Please click on the included link to reset your password.
              </p><a class="btn btn-primary btn-sm mt-3" href="../../authentication/basic/login.html"><span class="fas fa-chevron-left mr-1" data-fa-transform="shrink-4 down-1"></span>Return to login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
